import { render, staticRenderFns } from "./CommitmentDeclaration.vue?vue&type=template&id=5d3f40e8"
import script from "./CommitmentDeclaration.vue?vue&type=script&lang=js"
export * from "./CommitmentDeclaration.vue?vue&type=script&lang=js"
import style0 from "./CommitmentDeclaration.vue?vue&type=style&index=0&id=5d3f40e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports